import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { LuUserCheck } from "react-icons/lu";
import { TbLayout2, TbUsers } from "react-icons/tb";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchDepartments } from "../../redux/actions/departmentActions";
import {
  fetchHODMessages,
  addHODMessage,
  updateHODMessage,
} from "../../redux/actions/hodMessagesActions";
import { fetchStaff } from "../../redux/actions/staffActions";
import PageComponent from "../../Components/PageComponent";

function LeadershipMessages() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { data: hodMessages } = useSelector(
    (state) => state.hodMessages.hodMessages
  );
  const {
    data: departments,
    loading: deptLoading,
    error: deptError,
  } = useSelector((state) => state.department.department);
  const {
    data: staff,
    loading: staffLoading,
    error: staffError,
  } = useSelector((state) => state.staff.staffMembers);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      ["bold", "italic", "underline"],
      [{ align: [] }],
      ["clean"],
    ],
  };

  const formats = ["font", "header", "bold", "italic", "underline", "align"];

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [editMessage, setEditMessage] = useState({
    id: "",
    name: "",
    message: "",
    staffID: "", // Track original staff ID
  });
  const [isEditing, setIsEditing] = useState(false); // Track if editing or adding

  useEffect(() => {
    dispatch(fetchDepartments());
    dispatch(fetchStaff());
  }, [dispatch]);

  useEffect(() => {
    if (selectedDepartment) {
      dispatch(fetchHODMessages(selectedDepartment.id));
    }
  }, [selectedDepartment, dispatch]);

  const handleDepartmentChange = (id) => {
    const department = departments.find((dept) => dept.id === parseInt(id));
    if (department) {
      setSelectedDepartment(department);
      setEditMessage({ name: "", message: "" });
      setIsEditing(false);
    }
  };

  // useEffect(() => {
  //   if (hodMessages.length > 0 && selectedDepartment) {

  //     const existingMessage = hodMessages.find(
  //       (message) =>
  //         message.department_name === selectedDepartment?.department_name
  //     );
  //     if (existingMessage) {
  //       setEditMessage({
  //         id: existingMessage.staff_id, // Populate with staff_id
  //         name: existingMessage.staff_name, // Populate with staff_name for dropdown display
  //         message: existingMessage.message || "",
  //         staffID: existingMessage.staff_id || "", // Set original department ID
  //       });
  //       setIsEditing(true); // Switch to edit mode if a message exists
  //     } else {
  //       setEditMessage({ id: "", name: "", message: "" });
  //       setIsEditing(false); // Otherwise, stay in add mode
  //     }
  //   }
  // }, [hodMessages, selectedDepartment]);
  useEffect(() => {
    console.log("selectedDepartment:", selectedDepartment);
    console.log("hodMessages:", hodMessages);
  
    if (hodMessages.length > 0 && selectedDepartment && selectedDepartment.department_name) {
      const existingMessage = hodMessages.find(
        (message) =>
          message.department_name === selectedDepartment.department_name
      );
  
      console.log("existingMessage:", existingMessage);
  
      if (existingMessage) {
        setEditMessage({
          id: existingMessage.staff_id, // Populate with staff_id
          name: existingMessage.staff_name, // Populate with staff_name for dropdown display
          message: existingMessage.message || "",
          staffID: existingMessage.staff_id || "", // Set original department ID
        });
        setIsEditing(true); // Switch to edit mode if a message exists
      } else {
        setEditMessage({ id: "", name: "", message: "" });
        setIsEditing(false); // Otherwise, stay in add mode
      }
    }
  }, [hodMessages, selectedDepartment]);
  

  const handleAdd = () => {

    // Validation checks
  if (!selectedDepartment) {
    alert("Please select a department.");
    return;
  }

  if (!editMessage.id) {
    alert("Please select a staff member.");
    return;
  }

  const plainMessage = stripHtml(editMessage.message);

  if (!plainMessage.trim()) {
    alert("Message cannot be empty.");
    return;
  }
    const staffId = editMessage.id; // Extract staff_id separately
    const newMessage = {
      department: selectedDepartment.id,
      message: editMessage.message,
      staff_id: staffId, // Include staff_id
    };

    if (staffId) {
      dispatch(addHODMessage(newMessage)); // Dispatch with staff_id
      alert("HOD message added successfully");
    } else {
      dispatch(addHODMessage(newMessage)); // Dispatch without staff_id if not selected
    }
window.location.reload(true);
    setEditMessage({ id: "", name: "", message: "" });
  };

  // const handleUpdate = () => {
  //   const staffIDToSend =
  //    formData.department !== initialData.department_name
  //      ? formData.department
  //      : formData.departmentID;

  //   const staffId = editMessage.id; // Extract staff_id separately
  //   const updatedMessage = {
  //     department: selectedDepartment.id,
  //     message: editMessage.message,
  //     staff_id: staffId, // Include staff_id
  //   };

  //   if (staffId) {
  //     dispatch(updateHODMessage(updatedMessage, staffId)); // Pass staff_id for update
  //     alert("HOD message updated successfully");
  //   } else {
  //     alert("Failed to update: staff_id is missing.");
  //   }
  // };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  
  const handleStaffChange = (e) => {
    const selectedStaff = staff.find((s) => s.id === parseInt(e.target.value));
    if (selectedStaff) {
      setEditMessage((prev) => ({
        ...prev,
        id: selectedStaff.id,
        name: selectedStaff.staff_name,
      }));
    }
  };
  
  const handleUpdate = () => {

        // Validation checks
      if (!selectedDepartment) {
        alert("Please select a department.");
        return;
      }

      // if (!editMessage.id) {
      //   alert("Please select a staff member.");
      //   return;
      // }

      const plainMessage = stripHtml(editMessage.message);

      if (!plainMessage.trim()) {
        alert("Message cannot be empty.");
        return;
      }

    // Determine the staffID to send
    const staffIDToSend =
      editMessage.name !== hodMessages.find((msg) => msg.id === editMessage.id)?.staff_name
        ? editMessage.id
        : editMessage.staffID;
  
    const updatedMessage = {
      department: selectedDepartment.id,
      message: editMessage.message,
      staff_id: staffIDToSend, // Use determined staff ID
    };
    if (staffIDToSend) {
      dispatch(updateHODMessage(updatedMessage, editMessage.id)); // Update with staff ID
      alert("HOD message updated successfully");
    } else {
      alert("Failed to update: staff_id is missing.");
    }
  };
  

  const handleClear = () => {
    setEditMessage({ id: "", name: "", message: "" });
    setIsEditing(false);
  };

  return (
    <>
    <PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        {/* Page Title */}
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Academics & International</span>
          <span>/</span>
          <span className="text-black">Department Management</span>
        </div>

        {/* Buttons */}
        <div className="flex items-center mt-4 space-x-4">
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate(
                "/academics&international/departmentManagement/department"
              )
            }
          >
            <TbLayout2 className="mr-2" />
            Department
          </button>
          <button
            className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
            onClick={() =>
              navigate(
                "/academics&international/departmentManagement/leadershipMessages"
              )
            }
          >
            <LuUserCheck className="mr-2" />
            Leadership Messages
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate(
                "/academics&international/departmentManagement/academicStaff"
              )
            }
          >
            <TbUsers className="mr-2" />
            Academic Staff
          </button>
          <button
            className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
            onClick={() =>
              navigate("/academics&international/departmentManagement/allStaff")
            }
          >
            <TbUsers className="mr-2" />
            All Staff
          </button>
        </div>

        {/* Select Department */}
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <form>
            <h2 className="mb-4 text-xl font-semibold text-gray-700">
              Select Department
            </h2>
            <div>
              <select
                className="w-1/2 px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                onChange={(e) => handleDepartmentChange(e.target.value)}
                defaultValue=""
              >
                <option value="" disabled>
                  Select a Department
                </option>
                {deptLoading ? (
                  <option>Loading...</option>
                ) : deptError ? (
                  <option>{deptError}</option>
                ) : (
                  departments?.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.department_name}
                    </option>
                  ))
                )}
              </select>
            </div>
          </form>
        </div>

        {/* Add or Edit Department Form */}
        {selectedDepartment && (
          <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
            <form>
              <h2 className="mb-4 text-xl font-semibold text-gray-700">
                {isEditing ? "Edit HOD Message" : "Add HOD Message"}
              </h2>
              <div className="space-y-4">
                {/* Staff Name Dropdown */}
                {/* <div>
                  <label className="block text-gray-700">Name</label>
                  <select
                    value={editMessage.id} // Bind to staff_id
                    onChange={(e) =>
                      setEditMessage({
                        ...editMessage,
                        id: e.target.value, // Update staff_id
                        name: staff.find(
                          (member) => member.id === parseInt(e.target.value)
                        )?.name, // Find the name for display purposes
                      })
                    }
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  >
                    {editMessage.id && !staffLoading && !staffError && (
                      <option key="selected-staff" value={editMessage.id}>
                        {editMessage.name}
                      </option>
                    )}
                    {staffLoading ? (
                      <option>Loading...</option>
                    ) : staffError ? (
                      <option>{staffError}</option>
                    ) : (
                      staff
                        ?.filter((member) => member.id !== editMessage.id)
                        .map((member) => (
                          <option key={member.id} value={member.id}>
                            {member.name}
                          </option>
                        ))
                    )}
                  </select>
                </div> */}
              <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium text-gray-600">Select Staff</label>
                  <select
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                    value={editMessage.id || ""}
                    onChange={handleStaffChange}
                  >
                    <option value="" disabled>
                      {editMessage.name || "Select staff"}
                    </option>
                    {!staffLoading && !staffError ? (
                      staff.length > 0 ? (
                        staff.map((member) => (
                          <option key={member.id} value={member.id}>
                            {member.name}
                          </option>
                        ))
                      ) : (
                        <option disabled>No staff available</option>
                      )
                    ) : staffLoading ? (
                      <option>Loading...</option>
                    ) : (
                      <option disabled>{staffError}</option>
                    )}
                  </select>
                </div>

                {/* Message Field with ReactQuill */}
                <div>
                  <label className="block text-gray-700">Message</label>
                  <ReactQuill
                    value={editMessage.message}
                    onChange={(value) =>
                      setEditMessage({ ...editMessage, message: value })
                    }
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    className="h-[180px]"
                  />
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end mt-12 space-x-4">
                <button
                  type="reset"
                  onClick={handleClear}
                  className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
                >
                  Clear
                </button>
                {isEditing ? (
                  <button
                    type="button"
                    onClick={handleUpdate}
                    className="px-4 py-2 rounded-md bg-[#92288C] text-white hover:bg-[#6C0B67]"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={handleAdd}
                    className="px-4 py-2 rounded-md bg-[#92288C] text-white hover:bg-[#6C0B67]"
                  >
                    Add
                  </button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
    </PageComponent></>
  );
}

export default LeadershipMessages;
